import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { TakataRecallService } from '../../takata-recall/takata-recall.service';
import { VideosService } from '../videos.service';

import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { APP_SETTINGS } from '@services';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { NgIf, NgStyle, NgFor, DatePipe } from '@angular/common';
import { ShareContentComponent } from '../../share-content/share-content.component';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';


@Component({
    selector: 'app-videos-playback',
    templateUrl: './videos-playback.component.html',
    styleUrls: ['./videos-playback.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgStyle, NgFor, RouterLink, ShareContentComponent, DatePipe, HighlightSearchPipe]
})
export class VideosPlaybackComponent implements OnInit, OnDestroy {

  public vimeoBaseUrl = 'https://player.vimeo.com/video/';
  public vimeoSafeUrl: SafeResourceUrl;
  public videosList: any;
  public screenWidth: any;
  public currentVideo: any;
  public likeOrDislikeVideo: string;
  public videoLiked = false;
  public videoDisliked = false;
  private subscription: ISubscription[];
  public isVideoWatchlisted: boolean;
  public showSpinner = false;
  private isPlayAll = false;
  private isWatchlist = false;
  private watchlist;
  private currentVideoIndex = 0;
  public toggleAutoplay = false;
  public videoFile = '';
  public shareContentObject = {};
  public search4channel;
  APP_SETTINGS: any;
  //api: VgAPI;

  public videoThumbnail = APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail : APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  private username: string;
  public dateFormat: string;

  constructor(public sanitizer: DomSanitizer, private videoService: VideosService,
    private router: Router,
    private route: ActivatedRoute,
    private changeDetector: ChangeDetectorRef,
    private takataRecallService: TakataRecallService,
    private utilityService: UtilityService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private toastService: ToastConfigService,
    private analyticsService: AnalyticsService,
    private userProfileService: UserProfileService
  ) {
    this.screenWidth = this.utilityService.getScreenWidth();
    window.scrollTo(0, 0);
  }

  ngOnInit() {
    this.APP_SETTINGS = APP_SETTINGS;
    this.username = this.authService.getUserName();
    this.dateFormat = 'yyyy-MM-dd';
    this.subscription = [];
    this.videosList = [];
    this.subscription.push(this.route.queryParams.subscribe(params => {
      // tslint:disable-next-line:quotemark
      this.isWatchlist = params['watchlist'] === "true" ? true : false;
      // tslint:disable-next-line:quotemark
      const takata = params['takata'] === "true" ? true : false;
      this.spinnerService.show('bmwSpinner');
      if (takata) {
        this.subscription.push(this.takataRecallService.getTakataRecallVideos().subscribe(value => {
          this.spinnerService.hide('bmwSpinner');
          this.videosList = value;
          const videoId = +params['video'];
          this.currentVideo = this.videosList.find(video => video.id === videoId);
          this.videoFile = this.vimeoBaseUrl + this.currentVideo.videoFileName;
          this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoFile);
          //Analytics Call
          // this.analyticsCall('Takata Recall', this.currentVideo.videoDisplayNumber, this.videoFile);
          if (APP_SETTINGS.isAdmin === 'true') {
            this.analyticsCallAdmintrack('Takata Recall', this.currentVideo.videoDisplayNumber, this.authService.getUserName());
          }
          else {
            this.analyticsCall('Takata Recall', this.currentVideo.videoDisplayNumber, this.videoFile);
          }
          if (APP_SETTINGS.isExternal === 'true') {
            this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
              this.analyticsCallExternalContentTypeTrack('Takata Recall', this.currentVideo.videoDisplayNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
            });
          }
          if (APP_SETTINGS.isDealer === 'true') {
            this.analyticsService.trackDealerContentTypeLocation('Takata Recall', this.currentVideo.videoDisplayNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
              APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
          }
          this.applyUserPreferences();
        }, error => this.spinnerService.hide('bmwSpinner')));
      }
      if (this.isWatchlist) {
        // tslint:disable-next-line:quotemark
        this.isPlayAll = params['playAll'] === "true" ? true : false;
        this.videoService.getUsersWatchlist(this.username).subscribe(value => {
          this.spinnerService.hide('bmwSpinner');
          this.videosList = value;
          const videoId = +params['video'] || this.videosList[0]['id'];
          this.currentVideoIndex = this.videosList.findIndex(video => video.id === videoId);
          this.currentVideo = this.videosList.find(video => video.id === videoId);
          this.videoFile = this.vimeoBaseUrl + this.currentVideo.videoFileName;
          this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoFile);
          //Analytics Call
          // this.analyticsCall('Videos', this.currentVideo.videoDisplayNumber, this.videoFile);
          if (APP_SETTINGS.isAdmin === 'true') {
            this.analyticsCallAdmintrack('Videos', this.currentVideo.videoDisplayNumber, this.authService.getUserName());
          }
          else {
            this.analyticsCall('Videos', this.currentVideo.videoDisplayNumber, this.videoFile);
          }
          if (APP_SETTINGS.isExternal === 'true') {
            this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
              this.analyticsCallExternalContentTypeTrack('Videos', this.currentVideo.videoDisplayNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
            });
          }
          if (APP_SETTINGS.isDealer === 'true') {
            this.analyticsService.trackDealerContentTypeLocation('Videos', this.currentVideo.videoDisplayNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
              APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
          }
          this.applyUserPreferences();
        }, error => this.spinnerService.hide('bmwSpinner'));
      } else {

        const channelNumber = params['channel'];
        const vimeoID = params['vimeoID'];

        if (vimeoID && vimeoID != null) {
          this.spinnerService.hide('bmwSpinner');
          this.videoFile = this.vimeoBaseUrl + params['vimeoID'];
          this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoFile);
          // this api also adds video to the history list

          this.videoService.postVideoViews(this.username, params['video']).subscribe(value => {});
        }

        this.videoService.getVideosFromChannel(channelNumber).subscribe(value => {
          setTimeout(() => {
            this.spinnerService.hide('bmwSpinner');
          }, 5000);



          this.videosList = value;

          this.currentVideo = this.videosList.find(video => video.id === +params['video']);
          if (!vimeoID || vimeoID == null) {
            this.videoFile = this.vimeoBaseUrl + this.currentVideo.videoFileName;
            this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoFile);
          }

          // for (let i = 0; i <= this.videosList.length; i++){
          let makenamelogo = this.videosList[0]['make'];
          if (makenamelogo.makeName === 'ROLLSROYCE') {
            this.videoThumbnail = APP_SETTINGS.rollsRoyceVideoThumbnail;
          }
          // }
          //Analytics Call

          if (APP_SETTINGS.isAdmin === 'true') {
            this.analyticsCallAdmintrack('Videos', this.currentVideo.videoDisplayNumber, this.authService.getUserName());
          }
          else {
            this.analyticsCall('Videos', this.currentVideo.videoDisplayNumber, this.videoFile);
          }
          if (APP_SETTINGS.isExternal === 'true') {
            this.userProfileService.getUsersInfoById(this.authService.getUserName()).subscribe(userData => {
              this.analyticsCallExternalContentTypeTrack('Videos', this.currentVideo.videoDisplayNumber, userData['address1'], userData['city'], userData['state'], userData['zipCode']);
            });
          }
          if (APP_SETTINGS.isDealer === 'true') {
            this.analyticsService.trackDealerContentTypeLocation('Videos', this.currentVideo.videoDisplayNumber, APP_SETTINGS.centerID, APP_SETTINGS.locationCode, APP_SETTINGS.marketCode,
              APP_SETTINGS.marketDescription, APP_SETTINGS.regionCode, APP_SETTINGS.regionDescription)
          }
          //this.videoFile = 'video_files/' + this.currentVideo.videoFileName; old code

          this.changeDetector.detectChanges();
          this.applyUserPreferences();
        }, error => this.spinnerService.hide('bmwSpinner'));
      }
    }));
    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));

  }
  shareContent(id, type, channel, videoDisplayNumber) {
    this.shareContentObject = {
      id: id,
      type: type,
      channel: channel,
      videoDisplayNumber: videoDisplayNumber
    };
  }

  analyticsCall(contentType, contentName, fileName) {
    this.analyticsService.tracDocumentsAttachmentViewByTypeLineMake(contentType, contentName, fileName);
  }
  analyticsCallExternalContentTypeTrack(contentType, contentName, userAddress, userCity, userState, userZipCode) {
    this.analyticsService.trackClicksByExternalContentType(contentType, contentName, userAddress, userCity, userState, userZipCode);
  }

  analyticsCallAdmintrack(contentType, contentName, userid) {
    this.analyticsService.trackClicksbyAdminUser(contentType, contentName, userid);
  }

  applyUserPreferences() {
    this.toggleLikeOrDislikeVideo();
    this.videoService.getUsersWatchlist(this.username).subscribe(data => {
      this.watchlist = data;
      this.isVideoWatchlisted = this.watchlist.some(video => video.id === this.currentVideo.id);
    }, error => this.spinnerService.hide('bmwSpinner'));
    this.changeDetector.detectChanges();
  }


  /*
  onPlayerReady(api: VgAPI) {
    this.api = api;
    this.changeDetector.detectChanges();
    let videoIndex = 0;
    // increment views when user starts playing the video
    this.subscription.push(this.api.getDefaultMedia().subscriptions.playing.subscribe(() => {
      // this api also adds video to the history list
      this.videoService.postVideoViews(this.username, this.currentVideo.id).subscribe(value => {
        if (value.hasOwnProperty('videoDisplayNumber')) {
          this.currentVideo = value;
          this.videoFile = this.vimeoBaseUrl + this.currentVideo.videoFileName ;
          this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoFile);
          this.changeDetector.detectChanges();
        }
      });
    }));
    // play the videos automatically when user clicks on 'Play All'
    if (this.isPlayAll) {
      videoIndex = this.currentVideoIndex;
      this.subscription.push(this.api.getDefaultMedia().subscriptions.ended.subscribe(() => {
        if (this.currentVideoIndex < this.videosList.length - 1) {
          this.showSpinner = true;
          setTimeout(() => {
            this.currentVideoIndex += 1;
            this.currentVideo = this.videosList[this.currentVideoIndex];
            this.videoFile = this.vimeoBaseUrl + this.currentVideo.videoFileName ;
            this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoFile);
            this.showSpinner = false;
            this.api.play();
          }, 4000);
        }
      }));
    }
  }

  replayByTen() {
    this.api.seekTime(this.api.currentTime - 10);
  }
  seekByTen() {
    this.api.seekTime(this.api.currentTime + 10);
  }
  */
  likeVideo() {
    this.spinnerService.show('bmwSpinner');
    this.videoService.postVideoLikes(this.username, this.currentVideo.id).subscribe(value => {
      if (value.hasOwnProperty('videoDisplayId')) {
        this.currentVideo = value;
        this.videoFile = this.vimeoBaseUrl + this.currentVideo.videoFileName;
        this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoFile);
        this.toggleLikeOrDislikeVideo("Liked");
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
        //Analytics Call
        this.analyticsService.trackRatingByTypeLineMake('Videos', this.currentVideo.videoDisplayNumber, 'rated');
      }
    }, error => this.spinnerService.hide('bmwSpinner'));
  }
  dislikeVideo() {
    this.spinnerService.show('bmwSpinner');
    this.videoService.postVideoDislikes(this.username, this.currentVideo.id).subscribe(value => {
      if (value.hasOwnProperty('videoDisplayId')) {
        this.currentVideo = value;
        this.videoFile = this.vimeoBaseUrl + this.currentVideo.videoFileName;
        this.vimeoSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.videoFile);
        this.toggleLikeOrDislikeVideo("Disliked");
        this.changeDetector.detectChanges();
        this.spinnerService.hide('bmwSpinner');
        //Analytics Call
        this.analyticsService.trackRatingByTypeLineMake('Videos', this.currentVideo.videoDisplayNumber, 'rated');
      }
    }, error => this.spinnerService.hide('bmwSpinner'));
  }
  toggleAddToWatchlist() {
    let watchList;
    this.spinnerService.show('bmwSpinner');
    this.videoService.toggleVideoWatchlist(this.username, this.currentVideo.id).subscribe(data => {
      watchList = data;
      if (data) {
        this.isVideoWatchlisted = !this.isVideoWatchlisted;
        this.spinnerService.hide('bmwSpinner');
      }
      // this.isVideoWatchlisted = watchList.some(video => video.id === this.currentVideo.id);
    },
      error => this.spinnerService.hide('bmwSpinner')
    );
  }
  addVideoToWatchlist() {
    //Analytics call
    this.analyticsService.trackSavedContentByTypeLineMake('Videos', this.currentVideo.videoDisplayNumber, 'saved');
    //Analytics call
    this.videoService.addVideoToWatchlist(this.username, this.currentVideo.id).subscribe(data => {
      if (data) {
        this.toastService.popToast('Video added to watchlist');
      }
    });
  }
  toggleLikeOrDislikeVideo(likedOrDisliked?: string) {
    this.likeOrDislikeVideo = likedOrDisliked;
    // this.spinnerService.show('bmwSpinner');
    this.videoLiked = false;
    this.videoDisliked = false;
    this.videoService.getUserVideoLikesDislikes(this.username, this.currentVideo.id).subscribe(data => {
      // this.spinnerService.hide('bmwSpinner');
      this.likeOrDislikeVideo = data['videoLikedOrDisliked'];
    });
  }

  ngOnDestroy(): void {
    this.subscription.forEach(s => s.unsubscribe());
  }

  screenRotate(event) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

}
